var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"bg bg--gray",attrs:{"fill-height":"","fluid":""}},[_c('LoginBox',[(_vm.loginContainer)?_c('LoginForm',{on:{"toggleContainer":_vm.toggleContainer}}):_vm._e(),(_vm.successContainer)?_c('Success'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }